module.exports = __webpack_public_path__ + "img/tree-01-b-trunk.32b89c80.png";